export default __webpack_public_path__ + "static/media/sponsor-icon.cc7028ee.webp";